import script from "./stockList.vue?vue&type=script&setup=true&lang=js"
export * from "./stockList.vue?vue&type=script&setup=true&lang=js"

import "./stockList.vue?vue&type=style&index=0&id=676e22f7&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-676e22f7"]])

export default __exports__